import React, {Component, PropTypes} from 'react';

import mapActions from '../../actions/map';

export default class SIMFatalError extends Component {

  static restartLoading () {
    mapActions.emit(mapActions.EVENTS.LOAD);
  }

  render () {
    var msg = this.props.message || 'Error loading your map, want to try again?';

    return (
      <button onClick={SIMFatalError.restartLoading}>{msg}</button>
    );
  }
}

SIMFatalError.propTypes = {
  message: PropTypes.string
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/fatalerror/index.jsx